import { Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ParkingZoneDto } from '../../../api/gen';
import { ParkingZoneItemComponent } from '../parking-zone-item/parking-zone-item.component';
import { ResponsiveBaseComponent, Role } from 'shared-lib';
import { RoleService } from '../../auth/role-service';

@Component({
  selector: 'app-parking-zone-list',
  imports: [CommonModule, ParkingZoneItemComponent],
  templateUrl: './parking-zone-list.component.html',
  styleUrl: './parking-zone-list.component.scss'
})
export class ParkingZoneListComponent extends ResponsiveBaseComponent implements OnInit {
  @Input() zones: ParkingZoneDto[] = [];
  @Input() parkingAreaId: string | undefined;
  @Output() zoneDetails = new EventEmitter<string>();
  @Output() newZone = new EventEmitter<string>();
  isAdmin = signal(false);
  private roleService = inject(RoleService);

  constructor(private router: Router) {
    super();
  }
  async ngOnInit(): Promise<void> {
    this.isAdmin.set(await this.roleService.checkAccess(Role.Administrator));
  }

  onZoneDetails(zoneId: string) {
    this.router.navigate(['/parking-zone', zoneId]);
  }

  onZoneEdit(zoneId: string) {
    this.router.navigate(['/parking-zone/edit', zoneId]);
  }

  onZoneDelete(zoneId: string) {
    this.router.navigate(['/parking-zone/delete', zoneId]);
  }

  onZoneUnassign(zoneId: string) {
    if (this.parkingAreaId) {
      this.router.navigate(['/parking-zone/unassign', zoneId, this.parkingAreaId]);
    }
  }

  onNewZone() {
    if (this.parkingAreaId) {
      this.newZone.emit(this.parkingAreaId);
    }
  }
}
